import React, { useState } from "react";
import Preloader from "components/preloader";
import { useInView } from "react-intersection-observer";
import s from "./index.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(s);

const Lazycover = ({ image, className, contain }) => {
	const [imageLoaded, setImageLoaded] = useState(false);

	const [coverRef, inView] = useInView({
		threshold: 0,
		triggerOnce: true
	});

	return (
		<>
			<div
				ref={coverRef}
				className={cx(s.image, className)}
				style={{
					backgroundImage: inView && `url(${image})`,
					backgroundSize: contain ? "contain" : "cover",
					opacity: imageLoaded ? 1 : 0
				}}
			/>
			{inView && (
				<img
					src={image}
					onLoad={() => setImageLoaded(true)}
					className={s.source}
					alt="Source Cover"
				/>
			)}

			<Preloader hide={!imageLoaded} className={s.preloader} />
		</>
	);
};

export default Lazycover;
